export class ThirdPartyTag {
  content_tag: string;
  scripts: Array<any>;
  pixels: Array<any>;
  constructor() {
    this.scripts = [];
    this.pixels = [];
  }
}

export class CreativeAttribute {
  skippable: boolean;
  video_duration: Number;
  audio_duration: Number;
  content_title;
  video_mime: Array<any>;
  audio_mime: Array<any>;
  skip_offset;

  constructor() {}
}

export class BdspCreative {
  name: string;
  ad_type:
    | "banner"
    | "html5"
    | "video"
    | "audio"
    | "native_image_content"
    | "native_video_content_inline"
    | "native_video_content_vast_vpaid_wrapper";
  state: "active" | "inactive";
  height: number;
  width: number;
  start_date;
  end_date;
  vendor_viewability_tracking: boolean;
  creative_addons: Array<any>;
  click_url: string;
  third_party_tag: ThirdPartyTag;
  upload_type: "file_upload" | "third_party_tag";
  is_asset_changed: boolean;
  attributes: CreativeAttribute;
  native_offer;

  constructor() {
    this.ad_type = "banner";
    this.state = "inactive";
    this.upload_type = "file_upload";
    this.is_asset_changed = false;
    this.vendor_viewability_tracking = false;
    this.creative_addons = [];
    this.third_party_tag = new ThirdPartyTag();
    this.attributes = new CreativeAttribute();
  }
}

export const BdspCrtvAdTypes = [
  { value: "banner", label: "Banner", toolTip: "" },
  { value: "html5", label: "HTML5", toolTip: "" },
  { value: "audio", label: "Audio", toolTip: "" },
  { value: "video", label: "Video", toolTip: "" },
  {
    value: "native_image_content",
    label: "Native Image Content",
    toolTip: "Requires a native offer association. Create one if none exists.",
  },
  {
    value: "native_video_content_inline",
    label: "Native Video Content",
    toolTip: "Requires a native offer association. Create one if none exists.",
  },
  {
    value: "native_video_content_vast_vpaid_wrapper",
    label: "Native Video Content - VAST Wrapper",
    toolTip: "Requires a native offer association. Create one if none exists.",
  },
];

export const audioMIMEOptions = [
  { value: "mp4", label: "MP4" },
  { value: "mpeg", label: "MPEG" },
  { value: "ogg", label: "OGG" },
  { value: "webm", label: "WEBM" },
  { value: "wav", label: "WAV" },
];

export const videoMIMEOptions = [
  { value: "flv", label: "FLV" },
  { value: "javascript", label: "Javascript" },
  { value: "video_mp4", label: "Video MP4" },
  { value: "webm", label: "WEBM" },
  { value: "quicktime", label: "Quicktime" },
  { value: "audio_mp4", label: "Audio MP4" },
  { value: "ogg", label: "OGG" },
  { value: "mpeg", label: "MPEG" },
];

export class NativeOffers {
  template_type: string;
  name: string;
  logo_asset_id: string;
  title_short: string;
  description_short: string;
  call_to_action: string;
  sponsored: string;
  notes: string;
  state: "active" | "inactive";
  logo_preview_url: string;

  constructor() {
    this.state = "inactive";
    this.template_type = "native_image_content";
  }
}

export const nativeTemplateOptions = [
  // { value: "native_app_promo_icon", label: "Native App Promo Icon"},
  // { value: "native_image_app_install", label: "Native Image App Install"},
  // { value: "native_video_app_install_inline", label: "Native Video App Install - Inline"},
  // { value: "native_video_app_install_vast_vpaid_wrapper", label: "Native Video App Install"},
  { value: "native_image_content", label: "Native Image Content" },
  {
    value: "native_video_content_inline",
    label: "Native Video Content",
  },
  {
    value: "native_video_content_vast_vpaid_wrapper",
    label: " Native Video Content - VAST Wrapper",
  },
];

export const bdspCrtvLimits = {
  banner: {
    name: "Banner",
    type: new Set(["image/jpeg", "image/jpg", "image/png", "image/gif"]),
    size: 409600,
    maxSize: "400 kb",
    allowedFiles: "jpeg, jpg, png, gif",
  },
  native_image_content: {
    name: "Native Image Content",
    nat_img_type: new Set([
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
    ]),
    size: 409600,
    maxSize: "400 kb",
    allowedImgFiles: "jpeg, jpg, png, gif",
    aspectRatio: "1200:627,16:9,4:3"
  },
  native_video_content_inline: {
    name: "Native Video Content",
    nat_img_type: new Set([
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
    ]),
    nat_vdo_type: new Set(["video/mp4", "video/webm", "video/quicktime"]),
    size: 409600,
    maxSize: "400 kb",
    allowedImgFiles: "jpeg, jpg, png, gif",
    allowedVdoFiles: "mp4, webm, mov",
    aspectRatio: "1200:627,16:9,4:3"
  },
  native_video_content_vast_vpaid_wrapper: {
    name: "Native Video Content - VAST Wrapper",
    nat_img_type: new Set([
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
    ]),
    size: 409600,
    maxSize: "400 kb",
    allowedImgFiles: "jpeg, jpg, png, gif",
    aspectRatio: "1200:627,16:9,4:3"
  },
  video: {
    name: "video",
    type: new Set(["video/mp4", "video/webm", "video/quicktime"]),
    size: 524288000,
    maxSize: "200 MB",
    allowedFiles: "mp4, webm, mov",
  },
  audio: {
    name: "Audio",
    type: new Set(["audio/mpeg", "audio/wav", "audio/ogg", "audio/x-ms-wma"]),
    size: 3145728,
    allowedFiles: "mp3, wav, ogg, wma",
    maxSize: "3 MB",
  },
  html5: {
    name: "HTML5",
    type: new Set(["text/html"]),
    allowedFiles: "html",
  }
};

export const crtvTypeWithAttr: ReadonlySet<string> = new Set([
  "video",
  "audio",
  "native_video_content_vast_vpaid_wrapper",
]);

export const crtvNativeTypes: ReadonlySet<string> = new Set([
  "native_image_content",
  "native_video_content_inline",
  "native_video_content_vast_vpaid_wrapper",
]);

export const crtvTagTypes: ReadonlySet<string> = new Set([
  "banner",
  "video",
]);

export enum BdspCrtvConstant {
  NAT_BDSP_MAX_NAME = 255,
  NAT_BDSP_MAX_TITLE = 25,
  NAT_BDSP_MAX_DESC = 90,
  NAT_BDSP_MAX_CTA = 15,
  NAT_BDSP_MAX_SPONSORED = 50,
  NAT_BDSP_MAX_NOTES = 255,
  MAX_THUMBNAIL_SIZE = 153600,
  MAX_NAT_IMG_SIZE = 409600,
  NAT_IMG_MIN_WIDTH = 480,
  MAX_THUMBNAIL_DIMENSION = 150,
}

export const creativeAddOnOptions = [
  {value: 'ias_banner_tag' , label: 'IAS Banner Tag'},
  {value: 'adchoices_small_top_left' , label: 'AdChoices (Small, top-left)'},
  {value: 'adchoices_small_top_right' , label: 'AdChoices (Small, top-right)'},
  {value: 'adchoices_small_bottom_right' , label: 'AdChoices (Small, bottom-right)'},
  {value: 'adchoices_small_bottom_left' , label: 'AdChoices (Small, bottom-left)'},
  {value: 'doubleverify_banner_tag' , label: 'DoubleVerify Banner Tag'},
  {value: 'human_fraud_sensor_banner_tag' , label: 'HUMAN FraudSensor Banner Tag'},
  {value: 'account_level' , label: 'Account Level'}
]
